export enum LoginQueryParam {
  COURSE_ID = 'courseId', // using token instead now
  TOKEN = 'token',
  ECR_ID = 'ecrId',
  REFRESH_TOKEN = 'refreshToken',
}
